import { useState, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { submitQuiz, cancelQuiz } from "../../services/quizApi";


import "./Quiz.css";

function QuizPlay() {

    const navigate = useNavigate();

    const location = useLocation();

    const {
        quiz,
        studentName,
        submissionId
    } = location.state || {};

    const [answers, setAnswers] = useState(

        quiz?.questions.map((question, index) => ({

            questionNumber: index + 1,

            selectedAnswer: null

        })) || []

    );

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleOptionChange = (

        questionNumber,

        selectedAnswer

    ) => {

        const updatedAnswers = [...answers];

        updatedAnswers[questionNumber - 1] = {

            questionNumber,

            selectedAnswer

        };

        setAnswers(updatedAnswers);

    };
    const handleSubmitQuiz = async () => {

        const unansweredQuestion = answers.find(

            (answer) => answer.selectedAnswer === null

        );

        if (unansweredQuestion) {

            setError(

                `Please answer Question ${unansweredQuestion.questionNumber}.`

            );

            return;

        }

        try {

            setLoading(true);

            setError("");

            const result = await submitQuiz({

                submissionId,

                answers

            });

            setSubmitted(true);

            navigate("/quiz-result", {

                state: {

                    result,

                    quiz,

                    studentName

                }

            });

        }

        catch (error) {

            setError(

                error.response?.data?.message ||

                "Failed to submit quiz."

            );

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        return () => {

            if (!submitted && submissionId) {

                cancelQuiz(submissionId).catch(console.error);

            }

        };

    }, [submitted, submissionId]);

    if (!quiz) {

        return (

            <div className="quiz-error">

                Quiz not found.

            </div>

        );

    }

    return (

        <div className="quiz-play-page">

            <div className="quiz-header">

                <h2>

                    {quiz.subject} Quiz

                </h2>

                <div className="quiz-info">

                    <p>

                        <strong>Student:</strong> {studentName}

                    </p>

                    <p>

                        <strong>Standard:</strong> {quiz.standard}

                    </p>

                    <p>

                        <strong>Total Questions:</strong> {quiz.numberOfQuestions}

                    </p>

                    <p>

                        <strong>Total Marks:</strong> {quiz.totalMarks}

                    </p>

                </div>

            </div>

            {

                error && (

                    <div className="quiz-error">

                        {error}

                    </div>

                )

            }

            <div className="questions-container">

                {

                    quiz.questions.map((question, questionIndex) => (

                        <div

                            key={questionIndex}

                            className="question-card"

                        >

                            <h3>

                                Q{questionIndex + 1}. {question.question}

                            </h3>

                            <div className="options-list">

                                {

                                    question.options.map((option, optionIndex) => (

                                        <label

                                            key={optionIndex}

                                            className="option-item"

                                        >

                                            <input

                                                type="radio"

                                                name={`question-${questionIndex}`}

                                                value={optionIndex + 1}

                                                checked={

                                                    answers[questionIndex]?.selectedAnswer === optionIndex + 1

                                                }

                                                onChange={() =>

                                                    handleOptionChange(

                                                        questionIndex + 1,

                                                        optionIndex + 1

                                                    )

                                                }

                                            />

                                            {option}

                                        </label>

                                    ))

                                }

                            </div>

                        </div>

                    ))

                }

            </div>

            <div className="submit-section">

                <button

                    className="submit-btn"

                    onClick={handleSubmitQuiz}

                    disabled={loading}

                >

                    {

                        loading

                            ? "Submitting..."

                            : "Submit Quiz"

                    }

                </button>

            </div>

        </div>

    );

}

export default QuizPlay;